'use client'

import Link from 'next/link'
import {
  FaArrowRight,
  FaComments,
  FaCrown,
  FaDiscord,
  FaGem,
  FaHeart,
  FaImages,
  FaLink,
  FaMagic,
  FaMoneyBillWave,
  FaRocket,
  FaUsers,
  FaVideo,
} from 'react-icons/fa'

// The icons the articles name (`iconName="FaMagic"` in src/app/articles/*.mdx). A fixed list on purpose:
// this used to `import('react-icons/fa')` and pick the icon by name, which needs every Font Awesome icon
// (about 1,600) in the build. A new icon is added here; an unknown name falls back to the arrow.
const ICONS = {
  FaArrowRight,
  FaComments,
  FaCrown,
  FaDiscord,
  FaGem,
  FaHeart,
  FaImages,
  FaLink,
  FaMagic,
  FaMoneyBillWave,
  FaRocket,
  FaUsers,
  FaVideo,
}

const ArticleButton = ({ title, iconName, url }) => {
  const Icon = ICONS[iconName] || FaArrowRight

  return (
    <Link
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-white flex flex-col justify-center items-start my-5"
    >
      <div className="px-5 py-3 bg-[var(--main-bg-color)] text-white rounded-xl focus:outline-none font-semibold shadow-lg flex justify-center items-center my-2 transition-transform duration-200 hover:scale-[1.03]">
        <Icon className="text-white mr-3" size={24} />
        {title}
      </div>
    </Link>
  )
}

export default ArticleButton
